import * as React from 'react';
import moment from 'moment';

import { usePerDiemParams } from 'pages/PerDiemArchive/params';
import { DateSelector } from 'components/Selectors';
import { OptionalDate } from './types';

interface EndDateSelectorProps {
  minDate?: OptionalDate;
  withDefaults?: boolean;
}

export const EndDateSelector: React.FC<EndDateSelectorProps> = (props) => {
  const { minDate } = props;
  let { withDefaults } = props;
  if (withDefaults === undefined) {
    withDefaults = true;
  }

  const { searchParams, setSearchParams } = usePerDiemParams(withDefaults);

  return (
    <DateSelector
      label="End Date"
      value={searchParams.endDate}
      onChange={(endDate) => setSearchParams({ endDate })}
      minDate={minDate}
      maxDate={moment().startOf('day')}
      errorMessage="Invalid date; Date must be entered in mm/dd/yyyy format and be between the start date and now."
    />
  );
};
